import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { TestRunSchedule, UpsertTestRunScheduleRequest } from '../models/test-run-schedule.model';

/** Zeitplan eines Rechner-Laufs (NEX-1758): ein Lauf hat hoechstens einen. */
@Injectable({ providedIn: 'root' })
export class TestRunScheduleService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/v1/projects`;

  private url(projectId: string, runId: string): string {
    return `${this.baseUrl}/${projectId}/test-runs/${runId}/schedule`;
  }

  /** `null`, wenn der Lauf keinen Zeitplan hat: Das Backend antwortet dann mit 404. */
  get(projectId: string, runId: string): Observable<TestRunSchedule | null> {
    return this.http
      .get<TestRunSchedule>(this.url(projectId, runId))
      .pipe(
        catchError((error: unknown) =>
          error instanceof HttpErrorResponse && error.status === 404 ? of(null) : throwError(() => error),
        ),
      );
  }

  save(projectId: string, runId: string, request: UpsertTestRunScheduleRequest): Observable<TestRunSchedule> {
    return this.http.put<TestRunSchedule>(this.url(projectId, runId), request);
  }

  delete(projectId: string, runId: string): Observable<void> {
    return this.http.delete<void>(this.url(projectId, runId));
  }
}
